import {
  STOCK_DICTIONARY_DELETE_TRANSLATION_SUCCESS,
  STOCK_DICTIONARY_DELETE_TRANSLATION_FAILURE,
  STOCK_DICTIONARY_DELETE_TRANSLATION_PENDING,
  STOCK_DICTIONARY_DELETE_TRANSLATION_DISMISS_ERROR,
} from '../constants';

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_DICTIONARY_DELETE_TRANSLATION_SUCCESS:
      return {
        ...state,
        deleteTranslationSuccess: true,
        deleteTranslationPending: false,
      }

    case STOCK_DICTIONARY_DELETE_TRANSLATION_FAILURE:
      return {
        ...state,
        deleteTranslationError: action.data.error,
        deleteTranslationPending: false,
      }

    case STOCK_DICTIONARY_DELETE_TRANSLATION_DISMISS_ERROR:
      return {
        ...state,
        deleteTranslationError: null,
        deleteTranslationPending: false,
      }

    case STOCK_DICTIONARY_DELETE_TRANSLATION_PENDING:
      // Loading
      return {
        ...state,
        deleteTranslationPending: true,
        deleteTranslationError: null,
        deleteTranslationSuccess: false,
      }

    default:
      return state
  }
}